import React, { useEffect, useState } from "react";
import {
  CircularProgress,
  Grid,
  withStyles,
} from "@material-ui/core";
import PageTitle from "../../../../components/PageTitle/PageTitle";
import HeaderRelatorio from "../../HeaderRelatorio";
import Table from "../../../../components/Table/Table";
import {
  findRelatorioProcedimentosOdontologicos,
  findRelatorioProcedimentosOdontologicosPdf,
  findRelatorioProcedimentosOdontologicosCsv,
} from "../../../../services/RelatorioService";
import { columns, filtersDefault, pageableDTODefault, tipoAcaoOptions } from "./constants";
import { TextFieldSearch } from "../../../../components/TextField";
import { findAllProfissionalSaude } from "../../../../services/ProfissionalSaudeService";
import { findAllSujeitoAtencaoSelect } from "../../../../services/SujeitoAtencaoService";
import PrintIcon from "../../../../components/Icon/Print";
import { Button } from "../../../../components/ui/Buttons";
import ImpressaoHtml from "../../../../components/Impressao/ImpressaoHtml";
import Notification from "../../../../components/Notification";
import RelatorioProcedimentosOdontologicosContent from "../../../../template/pdf/relatorio/ProcedimentosOdontologicos";
import ArrowDownloadIcon from "../../../../components/Icon/ArrowDownload";
import { base64Convert } from "../../../../utils/base64ToCsv";
import InputDateForm from "../../../../components/Input/InputDateForm";
import { inject } from "mobx-react";
import { observer } from "mobx-react-lite";
import Scroll from "../../../../components/InfiniteScroll/Scroll";
import MensagemListaVazia from "../../../../components/Mensagem/MensagemListaVazia";
import moment from "moment";

const styles = {
  filtros: {
    display: "flex",
    flexDirection: "row",
    alignItems: "flex-end",
    gap: "8px",
    padding: "13px 16px 8px 16px",
    boxShadow:
      "10px 10px 25px rgb(112 124 151 / 5%), 15px 15px 35px rgb(112 124 151 / 5%)",
    background: "#fff",
    marginTop: 1,
  },
  campoFiltro: {
    display: "flex",
    flexDirection: "column",
    width: "100%",
    maxWidth: "160px",
  },
  tituloFiltros: {
    color: "#868686",
    fontSize: "12px !important",
  },
  notchedOutline: {
    border: "0",
  },
  tableContainer: {
    overflow: "auto",
    margin: "16px",
    borderRadius: "16px",
    border: "1px solid rgba(0, 0, 0, 0.1)",
    background: "#fff",
    height: "calc(100vh - 251px)",
  },
  buttonsDownloadPrint: {
    display: "flex",
    position: "absolute",
    right: "14px",
    bottom: "78px",
    width: "88px",
    gap: "8px",
  },
};

const RelatorioProcedimentosOdontologicos = ({ classes, relatorioStore }) => {
  const [procedimentos, setProcedimentos] = useState([]);
  const [filters, setFilters] = useState(filtersDefault);
  const [last, setLast] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [pageableDTO, setPageableDTO] = useState(pageableDTODefault);
  const [procedimentosPrint, setProcedimentosPrint] = useState([]);
  const [isPrintMustache, setIsPrintMustache] = useState(false);
  const [notification, setNotification] = useState({
    isOpen: false,
    message: "",
    variant: "",
  });

  const {
    dataInicio,
    dataFim,
    paciente,
    profissionalAtendimento,
    tipoAcao,
  } = filters || {};

  useEffect(() => {
    loadProcedimentos({ resetValues: true });
  }, []);

  const loadProcedimentos = async (options) => {
    try {
      setIsLoading(true);

      const isValid = relatorioStore.verificaLimiteTresMeses(dataInicio, dataFim);
      if (!isValid) {
        showAlertMessage({
          isOpen: true,
          variant: "error",
          message: "O limite de noventa dias foi excedido!",
        });
        setIsLoading(false);
        return;
      }

      const currentPageNumber = options?.resetValues ? 0 : pageableDTO.pageNumber + 1;

      const variables = {
        pageableDto: {
          ...pageableDTO,
          pageNumber: currentPageNumber,
        },
        dataInicial: moment(dataInicio).format("YYYY-MM-DD"),
        dataFinal: moment(dataFim).format("YYYY-MM-DD"),
        ...(paciente && { sujeitoAtencaoId: paciente?.id }),
        ...(profissionalAtendimento?.id && {
          profissionalId: profissionalAtendimento?.id,
        }),
        ...(tipoAcao !== "TODOS" && { status: tipoAcao }),
      };

      const response = await findRelatorioProcedimentosOdontologicos(variables);
      const { content, last } = response;

      setProcedimentos(
        options?.resetValues
          ? [...content]
          : [...procedimentos, ...content]
      );
      setPageableDTO({
        ...pageableDTO,
        pageNumber: currentPageNumber,
      });
      setLast(last);
    } catch (error) {
      showAlertMessage({
        isOpen: true,
        variant: "error",
        message: "Erro ao carregar o relatório de procedimentos odontológicos",
      });
    } finally {
      setIsLoading(false);
    }
  };

  const handleFilters = (value, field) => {
    setFilters({ ...filters, [field]: value });
  };

  const loadProfissionaisSaude = async (search, loadedOptions, { page }) => {
    try {
      const { mostrarApenasProfissionaisAtivo } = relatorioStore.configuracaoUnidade || {};
      const { content, last } = (
        await findAllProfissionalSaude({
          pageNumber: page,
          search,
          ...(mostrarApenasProfissionaisAtivo && {
            ativo: mostrarApenasProfissionaisAtivo,
          }),
        })
      ).data.data.findAllProfissionalSaude;
      return {
        options: content,
        hasMore: !last,
        additional: {
          page: page + 1,
        },
      };
    } catch (error) {
      console.error(error);
    }
  };

  const loadPacientes = async (search, loadedOptions, { page }) => {
    try {
      const searchDTO = {
        search,
        pageNumber: page,
        pageSize: 30,
        sortDir: "ASC",
        sortField: "nome",
      };
      const { content, last } = await findAllSujeitoAtencaoSelect({
        searchDTO,
      });
      return {
        options: content,
        hasMore: !last,
        additional: {
          page: page + 1,
        },
      };
    } catch (error) {
      console.error(error);
    }
  };


  const handleDownloadCSV = async () => {
    try {
      const variables = {
        pageableDto: {
          sortDir: pageableDTO.sortDir,
          sortField: pageableDTO.sortField,
        },
        dataInicial: moment(dataInicio).format("YYYY-MM-DD"),
        dataFinal: moment(dataFim).format("YYYY-MM-DD"),
        ...(paciente && { sujeitoAtencaoId: paciente?.id }),
        ...(profissionalAtendimento?.id && {
          profissionalId: profissionalAtendimento?.id,
        }),
        ...(tipoAcao !== "TODOS" && { status: tipoAcao }),
      };

      const base64 = await findRelatorioProcedimentosOdontologicosCsv(variables);
      if (base64 === "error") return;
      const blob = base64Convert(base64);
      const url = window.URL.createObjectURL(blob);
      let link = document.createElement("a");
      link.setAttribute("href", url);
      link.setAttribute("download", "RelatorioProcedimentosOdontologicos.csv");
      document.body.appendChild(link);
      link.click();
    } catch {
      showAlertMessage({
        isOpen: true,
        variant: "error",
        message: "Erro ao baixar o relatório",
      });
    }
  };

  const handlePrint = async () => {
    const isValid = relatorioStore.verificaLimiteTresMeses(dataInicio, dataFim);
    if (!isValid) {
      showAlertMessage({
        isOpen: true,
        variant: "error",
        message: "O limite de noventa dias foi excedido!",
      });
      return;
    }

    try {
      const variables = {
        pageableDto: {
          sortDir: pageableDTO.sortDir,
          sortField: pageableDTO.sortField,
        },
        dataInicial: moment(dataInicio).format("YYYY-MM-DD"),
        dataFinal: moment(dataFim).format("YYYY-MM-DD"),
        ...(paciente && { sujeitoAtencaoId: paciente?.id }),
        ...(profissionalAtendimento?.id && {
          profissionalId: profissionalAtendimento?.id,
        }),
        ...(tipoAcao !== "TODOS" && { status: tipoAcao }),
      };

      const response = await findRelatorioProcedimentosOdontologicosPdf(variables);
      setProcedimentosPrint(response);
      setIsPrintMustache(true);
    } catch (error) {
      console.error(error);
    }
  };

  const showAlertMessage = (notification) => {
    setNotification(notification);

    const timeoutId = setTimeout(() => {
      closeAlertMessage();
      clearTimeout(timeoutId);
    }, 3000);
  };

  const closeAlertMessage = () => {
    const notification = {
      isOpen: false,
      message: "",
    };
    setNotification(notification);
  };

  const handleClickSearch = () => {
    if (dataInicio && dataFim) {
      loadProcedimentos({ resetValues: true });
    }
  };

  return (
    <div>
      <PageTitle title="Relatório - Procedimentos Odontológicos " />
      <HeaderRelatorio
        idPrefix="rel-pod"
        title="Procedimentos Odontológicos "
        hiddenFilter
        hiddenSearch
        hiddenButtons
        hiddenTotal
      />
      <div className={classes.filtros}>
        <div className={classes.campoFiltro}>
          <span className={classes.tituloFiltros}>dataInicio</span>
          <InputDateForm
            id="rel-pod-inp-ini"
            iconposition="end"
            openTo="day"
            views={["year", "month"]}
            value={filters.dataInicio || ""}
            onChange={(e) => handleFilters(e, "dataInicio")}
          />
        </div>
        <div className={classes.campoFiltro}>
          <span className={classes.tituloFiltros}>dataFim</span>
          <InputDateForm
            id="rel-pod-inp-fim"
            iconposition="end"
            openTo="day"
            views={["year", "month"]}
            value={filters.dataFim || ""}
            onChange={(e) => handleFilters(e, "dataFim")}
          />
        </div>
        <div className={classes.campoFiltro}>
          <span className={classes.tituloFiltros}>Paciente</span>
          <TextFieldSearch
            id="rel-pod-inp-pac"
            placeholder="Selecione"
            classNotched={classes.notchedOutline}
            loadOptions={loadPacientes}
            getOptionLabel={(option) => option?.nome}
            getOptionValue={(option) => option?.id}
            value={paciente}
            onChange={(e) => handleFilters(e, "paciente")}
            withPaginate
            debounceTimeout={300}
            additional={{
              page: 0,
            }}
            menuPosition="fixed"
          />
        </div>
        <div className={classes.campoFiltro}>
          <span className={classes.tituloFiltros}>Profissional</span>
          <TextFieldSearch
            id="rel-pod-sel-prf"
            placeholder="Selecione"
            classNotched={classes.notchedOutline}
            loadOptions={loadProfissionaisSaude}
            getOptionLabel={(option) => option?.nome}
            getOptionValue={(option) => option?.id}
            value={profissionalAtendimento}
            onChange={(e) => handleFilters(e, "profissionalAtendimento")}
            withPaginate
            debounceTimeout={300}
            additional={{
              page: 0,
            }}
            menuPosition="fixed"
          />
        </div>
        <div className={classes.campoFiltro}>
          <span className={classes.tituloFiltros}>Tipo de Ação</span>
          <TextFieldSearch
            id="rel-pod-sel-acao"
            placeholder="Selecione"
            classNotched={classes.notchedOutline}
            options={tipoAcaoOptions}
            getOptionLabel={(option) => option?.label}
            getOptionValue={(option) => option?.value}
            value={tipoAcaoOptions.find((opt) => opt.value === tipoAcao) || null}
            onChange={(e) => handleFilters(e?.value || "TODOS", "tipoAcao")}
            menuPosition="fixed"
            isSearchable={false}
          />
        </div>
        <div>
          <Button
            id="rel-pod-btn-fil"
            bgColor={"#707C97"}
            onClick={handleClickSearch}
            disabled={!dataInicio || !dataFim}
          >
            Filtrar
          </Button>
        </div>
      </div>
      <div className={classes.tableContainer}>
        <Scroll
          loadMore={() => loadProcedimentos({ resetValues: false })}
          hasMore={!last}
          pageStart={0}
          initialLoad={false}
        >
          <Table dados={procedimentos} columns={columns} />
          {procedimentos.length === 0 && !isLoading && <MensagemListaVazia />}
          {isLoading && (
            <Grid
              container
              justify="center"
              alignItems="center"
              style={{
                marginTop: 20,
                width: "100%",
                height: "100%",
                display: "flex",
                justifyContent: "center",
              }}
            >
              <CircularProgress size={30} />
            </Grid>
          )}
        </Scroll>

        <div className={classes.buttonsDownloadPrint}>
          <Button
            id="rel-pod-btn-imp"
            shape="circle"
            bgColor="#F9BE73"
            onClick={handlePrint}
            disabled={!dataInicio || !dataFim}
          >
            <PrintIcon />
          </Button>
          <Button
            id="rel-pod-btn-csv"
            shape="circle"
            bgColor="#F9BE73"
            onClick={handleDownloadCSV}
            disabled={!dataInicio || !dataFim}
          >
            <ArrowDownloadIcon />
          </Button>
        </div>

        {isPrintMustache && (
          <ImpressaoHtml
            isPrintMustache={isPrintMustache}
            handlePrintMustache={() => setIsPrintMustache(false)}
            htmlStringComponent={
              <RelatorioProcedimentosOdontologicosContent
                dadosRelatorio={procedimentosPrint || []}
                filters={filters}
              />
            }
          />
        )}

        <Notification
          close={closeAlertMessage}
          reset={closeAlertMessage}
          isOpen={notification.isOpen}
          variant={notification.variant}
          message={notification.message}
        />
      </div>
    </div>
  );
};

const RelatorioProcedimentosOdontologicosWithStyles = withStyles(styles)(
  observer(RelatorioProcedimentosOdontologicos)
);

const stores = ["relatorioStore"];
export default inject(...stores)(RelatorioProcedimentosOdontologicosWithStyles);
